export default __webpack_public_path__ + "static/typography-ga-improved-legibility-17691c4ff4dbd0a9218c92f41aff830599f41a11f3256377b23d831bb516b262.png";